import axios from 'axios';
import {
    GET_USERS_URL,
    GET_AGENTS_URL,
    GET_FARMERS_URL,
    GET_FARM_URL,
    FARM_ID_URL,
    COMPANY_ID_URL,
    SIGNIN_URL,
    REGISTER_ADMIN_URL,
    COMPANY_DATA_URL,
    REGISTER_COMPANY_URL,
    USER_DATA_URL,
    GET_COMPANIES_URL,
    VERIFY_COMPANY_URL,
    CROP_URL,
    UNVERIFY_COMPANY_URL,
    COMPANY_VERIFICATION_STATUS_URL,
    REVIEW_COMPANY_VERIFICATION_URL,
    COMPANY_REPRESENTATIVES_URL,
    GET_SCHEME_APPLICATION_URL,
    GET_SCHEME_APPS_BY_STATUS_URL,
    GET_PROVINCES_URL,
    GET_HARVEST_URL,
    GET_HARVEST_BY_CROP_URL,
    GET_CULTIVATION_AREA_URL,
    GET_FARMERS_BY_PROVINCE_URL,
    GET_FARMS_BY_PROVINCE_URL,
    GET_INPUT_DELIVERY_URL,
    INPUT_DELIVERY_ID_URL,
    GET_FARM_INSPECTIONS_URL,
    GET_ACTIVITY_LOG_URL,
    FARM_INSPECTION_ID_URL,
    GET_FARM_INSPECTION_VISITS_URL,
    GET_SCHEMES_URL,
    GET_FARMER_COMPLAINTS_URL,
    GET_SUPPORT_EMAILS_URL,
    GET_CULTIVATED_CROP_URL,
    PRESEASON_CONTRACT_ID_URL,
    PRESEASON_CONTRACT_PRICE_HISTORY_URL,
    PRESEASON_CONTRACT_APPLICATION_PRICE_BUCKETS_URL,
    PRESEASON_CONTRACT_QUANTITY_HISTORY_URL,
    GET_PRESEASON_APPLICATIONS_URL,
    GET_FINAL_CONTRACTS_URL,
    TRADE_OFFER_ID_URL,
    SELL_REQUEST_ID_URL,
    PRODUCT_ID_URL,
    GET_FARMER_INVENTORY_URL,
    GET_FARMS_BY_FARMER_URL,
    GET_SCHEME_APPLICATIONS_BY_FARMER_URL,
    GET_INPUT_DELIVERY_BY_FARMER_URL,
    GET_HARVEST_BY_FARMER_URL,
    GET_FARMER_INPUT_HISTORY_URL
} from './index';
import { toast } from 'react-toastify';
import {SET_AUTH_USER, UNSET_USER} from '../stores/auth';
import setAuthToken from "../utils/setAuthToken";
import errorHandler from "../utils/errorHandler";

export const login = (data) => {
    return function(dispatch) {
        //Save to localStorage
        return axios.post(SIGNIN_URL, data).then((response) => {
            const token = `Token ${response.data.token}`;

            //Set token to localStorage
            localStorage.setItem('jwtToken', token);

            //Set token to Auth header
            setAuthToken(token);

            dispatch(SET_AUTH_USER({user: response.data, isAuthenticated: true}));
            return { error: false };
        }).catch((error) => {
            const data = error.response?.data;
            const errorMessage =
                data?.detail ||
                data?.non_field_errors?.[0] ||
                "Login failed. Please check your credentials.";
            toast.error(errorMessage, {position: 'top-right', autoClose: 2000});
            return {
                error: true,
                payload: null
            };
        });
    }
};

export const logoutUser = () => {
    return function(dispatch) {
        //Remove toke from localStorage
        localStorage.clear();

        //Remove auth header for future requests
        setAuthToken(false);

        //Set current user to {} which will set isAuthenticated to false
        dispatch(UNSET_USER());
    }
};

export const getGlobal = () => {
    return axios.all([
        axios.get(GET_USERS_URL),
        axios.get(GET_COMPANIES_URL),
        axios.get(GET_FARMERS_URL),
        axios.get(GET_AGENTS_URL),
        axios.get(GET_FARM_URL)
    ]).then(axios.spread((response1, response2, response3, response4, response5) => {
        // Multiple requests are now complete
        return {
            users: response1.data,
            company: response2.data,
            farmers: response3.data,
            agents: response4.data,
            farms: response5.data
        }
    })).catch((error) => {
        errorHandler(error, "top-right");
        return {
            error: true
        }
    });
}

export const registerAdmin = (data) => {
    return axios.post(REGISTER_ADMIN_URL, data).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch(() => {
        return {
            payload: null,
            error: true
        }
    });
}

export const actionAdmin = (method, id, data) => {
    return axios({url: USER_DATA_URL(id), method: method, data: data}).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch(() => {
        return {
            payload: null,
            error: true
        }
    });
}

export const registerCompany = (data) => {
    return axios.post(REGISTER_COMPANY_URL, data).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch(() => {
        return {
            payload: null,
            error: true
        }
    });
}

export const actionCompany = (method, id, data) => {
    return axios({url: COMPANY_DATA_URL(id), method: method, data: data}).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch(() => {
        return {
            payload: null,
            error: true
        }
    });
}

export const verifyCompany = (method, id, data) => {
    return axios({url: VERIFY_COMPANY_URL(id), method: method, data: data}).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch((err) => {
        return {
            payload: err.response.statusText,
            error: true
        }
    });
}

export const getCompanyVerificationStatus = (pacraId = null) => {
    const config = pacraId ? { params: { pacra_id: pacraId } } : {};
    return axios.get(COMPANY_VERIFICATION_STATUS_URL, config).then((response) => {
        return {
            payload: response.data,
            error: false
        };
    }).catch((err) => {
        return {
            payload: err.response?.data?.error || err.response?.statusText || 'Failed to load company verification status.',
            error: true
        };
    });
}

// Fetch company representatives for the given company pacra id.
// Backend viewset reads `company_pacra_id` from request data.
export const getCompanyRepresentatives = (companyPacraId) => {
    return axios({
        url: COMPANY_REPRESENTATIVES_URL,
        method: 'get',
        data: { company_pacra_id: companyPacraId }
    }).then((response) => {
        return {
            payload: response.data,
            error: false
        };
    }).catch((err) => {
        return {
            payload: err.response?.data?.error || err.response?.statusText || 'Failed to load company representatives.',
            error: true
        };
    });
};

export const reviewCompanyVerification = (method, data) => {
    return axios({url: REVIEW_COMPANY_VERIFICATION_URL, method: method, data: data}).then((response) => {
        return {
            payload: response.data,
            error: false
        };
    }).catch((err) => {
        return {
            payload: err.response?.data?.error || err.response?.statusText || 'Failed to review company verification.',
            error: true
        };
    });
}

export const deactivateCompany = (method, id, data) => {
    return axios({url: UNVERIFY_COMPANY_URL(id), method: method, data: data}).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch((err) => {
        return {
            payload: err.response.statusText,
            error: true
        }
    });
}

export const getCompanyID = (id) => {
    const token = typeof localStorage !== 'undefined' ? localStorage.getItem('jwtToken') : null;
    const headers = token ? { Authorization: token } : {};
    return axios({
        url: COMPANY_ID_URL(id),
        method: "get",
        headers
    }).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch((err) => {
        if (err.response && err.response.status === 401) {
            toast.error('Session expired or unauthorized. Please log in again.', { position: 'top-right', autoClose: 3000 });
        }
        return {
            payload: null,
            error: true
        }
    });
}

export const getInputDeliveryById = (id) => {
    return axios({url: INPUT_DELIVERY_ID_URL(id), method: "get"}).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch(() => {
        return {
            payload: null,
            error: true
        }
    });
}

export const getFarmById = (id) => {
    return axios({url: FARM_ID_URL(id), method: "get"}).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch(() => {
        return {
            payload: null,
            error: true
        }
    });
}

export const getPreSeasonContractById = (id) => {
    return axios({url: PRESEASON_CONTRACT_ID_URL(id), method: "get"}).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch(() => {
        return {
            payload: null,
            error: true
        }
    });
}

export const getTradeOfferById = (id) => {
    return axios({url: TRADE_OFFER_ID_URL(id), method: "get"}).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch(() => {
        return {
            payload: null,
            error: true
        }
    });
}

export const getSellRequestById = (id) => {
    return axios({url: SELL_REQUEST_ID_URL(id), method: "get"}).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch(() => {
        return {
            payload: null,
            error: true
        }
    });
}

export const getProductById = (id) => {
    return axios({url: PRODUCT_ID_URL(id), method: "get"}).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch(() => {
        return {
            payload: null,
            error: true
        }
    });
}

export const getUserById = (id) => {
    return axios({url: USER_DATA_URL(id), method: "get"}).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch(() => {
        return {
            payload: null,
            error: true
        }
    });
}

export const getFarmerInventory = (farmerId) => {
    return axios.get(GET_FARMER_INVENTORY_URL(farmerId)).then((response) => {
        const data = Array.isArray(response.data) ? response.data : (response.data?.results ?? response.data?.data ?? []);
        return { payload: data, error: false };
    }).catch(() => ({ payload: [], error: true }));
}

export const getFarmsByFarmerId = (farmerId) => {
    return axios.get(GET_FARMS_BY_FARMER_URL, { params: { id: farmerId } }).then((response) => {
        const data = response.data;
        const list = Array.isArray(data) ? data : (data?.results ?? data?.data ?? []);
        return { payload: list, error: false };
    }).catch(() => ({ payload: [], error: true }));
}

export const getSchemeApplicationsByFarmerId = (farmerId) => {
    return axios.get(GET_SCHEME_APPLICATIONS_BY_FARMER_URL, { params: { farmer_id: farmerId } }).then((response) => {
        const data = response.data;
        const list = Array.isArray(data) ? data : (data?.results ?? data?.data ?? []);
        return { payload: list, error: false };
    }).catch(() => ({ payload: [], error: true }));
}

export const getInputDeliveriesByFarmerId = (farmerId) => {
    return axios.get(GET_INPUT_DELIVERY_BY_FARMER_URL, { params: { farmer_id: farmerId } }).then((response) => {
        const data = response.data;
        const list = Array.isArray(data) ? data : (data?.results ?? data?.data ?? []);
        return { payload: list, error: false };
    }).catch(() => ({ payload: [], error: true }));
}

export const getHarvestByFarmerId = (farmerId) => {
    return axios.get(GET_HARVEST_BY_FARMER_URL, { params: { farmer_id: farmerId } }).then((response) => {
        const data = response.data;
        const list = Array.isArray(data) ? data : (data?.results ?? data?.data ?? []);
        return { payload: list, error: false };
    }).catch(() => ({ payload: [], error: true }));
}

export const getFarmerInputHistory = () => {
    return axios.get(GET_FARMER_INPUT_HISTORY_URL).then((response) => {
        const data = response.data;
        const list = Array.isArray(data) ? data : (data?.results ?? data?.data ?? []);
        return { payload: list, error: false };
    }).catch(() => ({ payload: [], error: true }));
}

export const getPreseasonApplications = () => {
    return axios.get(GET_PRESEASON_APPLICATIONS_URL).then((response) => {
        const data = response.data;
        const list = Array.isArray(data) ? data : (data?.results ?? data?.data ?? []);
        return {
            payload: list,
            error: false
        };
    }).catch(() => ({
        payload: [],
        error: true
    }));
}

export const getPreseasonPriceHistory = (contractId) => {
    return axios.get(PRESEASON_CONTRACT_PRICE_HISTORY_URL(contractId)).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch((err) => {
        return {
            payload: null,
            error: true
        }
    });
}

export const getPreseasonApplicationPriceBuckets = (contractId) => {
    return axios
        .get(PRESEASON_CONTRACT_APPLICATION_PRICE_BUCKETS_URL(contractId))
        .then((response) => ({ payload: response.data, error: false }))
        .catch(() => ({ payload: null, error: true }));
};

export const getPreseasonQuantityHistory = (contractId) => {
    return axios.get(PRESEASON_CONTRACT_QUANTITY_HISTORY_URL(contractId)).then((response) => {
        return {
            payload: response.data,
            error: false
        };
    }).catch(() => ({
        payload: null,
        error: true
    }));
}

export const getFinalContractsByContractId = (contractId) => {
    return axios.get(GET_FINAL_CONTRACTS_URL, { params: { contract: contractId } }).then((response) => {
        const data = response.data;
        const list = Array.isArray(data) ? data : (data?.results ?? data?.data ?? []);
        return {
            payload: list,
            error: false
        };
    }).catch(() => ({
        payload: [],
        error: true
    }));
}

export const createCrop = (data) => {
    return axios.post(CROP_URL, data).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch(() => {
        return {
            payload: null,
            error: true
        }
    });
}

export const getSchemeApplicationsByStatus = (status) => {
    return axios.get(GET_SCHEME_APPS_BY_STATUS_URL, {
        params: { app_status: status }
    }).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch(() => {
        return {
            payload: null,
            error: true
        }
    });
}

export const getAllSchemeApplications = () => {
    return axios.get(GET_SCHEME_APPLICATION_URL).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch(() => {
        return {
            payload: null,
            error: true
        }
    });
}

export const getProvinces = () => {
    return axios.get(GET_PROVINCES_URL).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch(() => {
        return {
            payload: null,
            error: true
        }
    });
}

export const getAllHarvests = () => {
    return axios.get(GET_HARVEST_URL).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch(() => {
        return {
            payload: null,
            error: true
        }
    });
}

export const getHarvestByCrop = (cropId) => {
    return axios.get(GET_HARVEST_BY_CROP_URL, {
        params: { crop_id: cropId }
    }).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch(() => {
        return {
            payload: null,
            error: true
        }
    });
}

export const getCultivationArea = (regionId = null) => {
    const params = regionId ? { region_id: regionId } : {};
    return axios.get(GET_CULTIVATION_AREA_URL, { params }).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch(() => {
        return {
            payload: null,
            error: true
        }
    });
}

export const getFarmersByProvince = () => {
    return axios.get(GET_FARMERS_BY_PROVINCE_URL).then((response) => {
        return {
            payload: Array.isArray(response.data) ? response.data : [],
            error: false
        };
    }).catch(() => ({
        payload: [],
        error: true
    }));
}

export const getFarmsByProvince = () => {
    return axios.get(GET_FARMS_BY_PROVINCE_URL).then((response) => {
        return {
            payload: Array.isArray(response.data) ? response.data : [],
            error: false
        };
    }).catch(() => ({
        payload: [],
        error: true
    }));
}

export const getAllInputDeliveries = () => {
    return axios.get(GET_INPUT_DELIVERY_URL).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch(() => {
        return {
            payload: null,
            error: true
        }
    });
}

export const getAllFarmInspections = () => {
    return axios.get(GET_FARM_INSPECTIONS_URL).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch(() => {
        return {
            payload: null,
            error: true
        }
    });
}

export const getRecentActivity = () => {
    return axios.get(GET_ACTIVITY_LOG_URL).then((response) => {
        const data = response.data;
        const list = Array.isArray(data) ? data : (data?.results ?? data?.data ?? []);
        return { payload: Array.isArray(list) ? list : [], error: false };
    }).catch(() => ({ payload: [], error: true }));
}

export const getFarmInspectionsByFarmId = (farmId) => {
    return axios.get(GET_FARM_INSPECTIONS_URL, { params: { farm__id: farmId } }).then((response) => {
        const data = response.data;
        const list = Array.isArray(data) ? data : (data?.results ?? data?.data ?? []);
        return { payload: list, error: false };
    }).catch(() => ({ payload: [], error: true }));
}

export const getFarmInspectionById = (id) => {
    return axios({ url: FARM_INSPECTION_ID_URL(id), method: "get" }).then((response) => ({
        payload: response.data,
        error: false
    })).catch(() => ({ payload: null, error: true }));
}

export const getFarmInspectionVisitsByInspectionId = (inspectionId) => {
    return axios.get(GET_FARM_INSPECTION_VISITS_URL, { params: { farm_inspection__id: inspectionId } }).then((response) => {
        const data = response.data;
        const list = Array.isArray(data) ? data : (data?.results ?? data?.data ?? []);
        return { payload: list, error: false };
    }).catch(() => ({ payload: [], error: true }));
}

export const getAllSchemes = () => {
    return axios.get(GET_SCHEMES_URL).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch(() => {
        return {
            payload: null,
            error: true
        }
    });
}

export const getAllFarmerComplaints = () => {
    return axios.get(GET_FARMER_COMPLAINTS_URL).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch(() => {
        return {
            payload: null,
            error: true
        }
    });
}

export const getAllSupportEmails = () => {
    return axios.get(GET_SUPPORT_EMAILS_URL).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch(() => {
        return {
            payload: null,
            error: true
        }
    });
}

export const getCultivatedCrops = (cropId = null, regionId = null) => {
    const params = {};
    if (cropId) params.crop_id = cropId;
    if (regionId) params.region_id = regionId;
    return axios.get(GET_CULTIVATED_CROP_URL, { params }).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch(() => {
        return {
            payload: null,
            error: true
        }
    });
}
